import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CommonSelect } from "../common";
import { TroubleshootRounded } from "@mui/icons-material";
import {
  numberFormatter,
} from "../../utils/generalFunctions";

//inline styles
const InlineStyles = {
  TableHeader: {
    backgroundColor: "#262671",
    color: "white",
    position: "sticky",
    top: 0,
    zIndex: 1,
    height: "50px",
  },
  TableCells: {
    color: "black",
    fontSize: "12px",
    height: "44px",
    padding: "0px",
  },
  TableBodyRows: {
    border: "1px solid #ddd",
    marginTop: "10px",
    paddingTop: "15px",
    verticalAlign: "middle",
    height: "50px",
  },
  TableBodyRowCells: {
    height: "20px",
    padding: "0px",
  },
  PaymentReceiveDate: {
    width: "120px",
    height: "33px",
    padding: "0px",
    maxWidth: "120px",
  },
  BrokerBranchTableCell: {
    height: "20px",
    padding: "3px",
    // width:"150px"
  },
  ReceivableAmountTableCell: {
    height: "20px",
    padding: "3px",
  },
  PaymentCurrencyCodeTableCell: {
    height: "20px",
    padding: "3px",
  },
  BankExchangeRateTableCell: {
    height: "20px",
    padding: "3px",
  },
  BankExchangeChargesTableCell: {
    height: "20px",
    padding: "3px",
  },
  PaymentReferenceTableCell: {
    height: "20px",
    padding: "3px",
  },
  PaymentReference: {
    position: "relative",
    width: "83px",
    height: "32",
  },
  PaymentCurrency: {
    position: "relative",
    width: "80px",
    height: "32",
  },
  MoreVertIconStyle: {
    color: "#1672DE",
    background: "transparent",
    cursor: "pointer",
    transform: "rotate(90deg)",
  },
  BankChargesTableCell: {
    height: "20px",
    padding: "3px",
  },
};

export const AddUpload = ({
  dropdownValuesCurreny,
  selectAll,
  handleSelectAll,
  handleInputChange,
  handleCheckboxChange,
  handleBlur,
  rows,
  validationStatus,
  handlePaymentReferenceOpenDialog,
  selectedRows,
}) => {
  return (
    <Table>
      <TableHead>
        <TableRow 
          sx={{
            backgroundColor: "#1672DE",
            "& .MuiTableCell-root": {
              color: "#ffffff",
              fontWeight: "600",
              fontSize: "12px",
              padding: "8px 6px",
              borderBottom: "2px solid rgba(255, 255, 255, 0.2)",
              transition: "all 0.2s ease",
            },
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          <TableCell sx={{ width: "40px", maxWidth: "40px", minWidth: "40px", padding: "8px 4px", textAlign: "center" }}>
            <Checkbox
              checked={selectAll}
              onChange={(e) => handleSelectAll(e)}
              sx={{
                color: "#ffffff",
                "&.Mui-checked": {
                  color: "#ffffff",
                },
                "& .MuiSvgIcon-root": {
                  color: "#ffffff",
                },
              }}
            />
          </TableCell>
          <TableCell sx={{ width: "100px", maxWidth: "100px", minWidth: "100px", padding: "8px 6px", textAlign: "left" }}>Payment Date</TableCell>
          <TableCell sx={{ width: "120px", maxWidth: "120px", minWidth: "120px", padding: "8px 6px", textAlign: "left" }}>Bank Txn Id</TableCell>
          <TableCell sx={{ width: "110px", maxWidth: "110px", minWidth: "110px", padding: "8px 6px", textAlign: "left" }}>
            Payment <br />
            Reference
          </TableCell>
          <TableCell sx={{ width: "90px", maxWidth: "90px", minWidth: "90px", padding: "8px 6px", textAlign: "left" }}>
            Original <br />
            Currency
          </TableCell>
          <TableCell sx={{ width: "100px", maxWidth: "100px", minWidth: "100px", padding: "8px 6px", textAlign: "right" }}>
            Payment <br />
            Amount
          </TableCell>
          <TableCell sx={{ width: "90px", maxWidth: "90px", minWidth: "90px", padding: "8px 6px", textAlign: "left" }}>Broker Name</TableCell>
          <TableCell sx={{ width: "100px", maxWidth: "100px", minWidth: "100px", padding: "8px 6px", textAlign: "left" }}>Assignment</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={index} style={InlineStyles.TableBodyRows}>
            <TableCell sx={{ ...InlineStyles.TableBodyRowCells, width: "40px", maxWidth: "40px", minWidth: "40px", padding: "2px", textAlign: "center", verticalAlign: "middle" }}>
              <Checkbox
                checked={
                  selectAll
                    ? selectAll
                    : selectedRows.findIndex((item) => item?.id === row.id) !==
                      -1
                }
                onChange={(e) => handleCheckboxChange(row, e.target.checked)}
                sx={{
                  color: "#1672DE",
                  "&.Mui-checked": {
                    color: "#1672DE",
                  },
                  "& .MuiSvgIcon-root": {
                    color: "#1672DE",
                  },
                }}
              />
            </TableCell>
            <TableCell sx={{ padding: "2px", width: "100px", maxWidth: "100px", minWidth: "100px", textAlign: "left", verticalAlign: "middle" }}>
              <input
                type="date"
                value={
                  row.Payment_Receive_Date
                    ? row.Payment_Receive_Date.substring(0, 10)
                    : ""
                }
                onChange={(e) =>
                  handleInputChange(
                    index,
                    "Payment_Receive_Date",
                    e.target.value
                  )
                }
                style={{
                  ...InlineStyles.PaymentReceiveDate,
                  backgroundColor: "#f8f9fa",
                  border: "1.5px solid rgba(22, 114, 222, 0.15)",
                  borderRadius: "8px",
                  padding: "6px 8px",
                  fontSize: "11px",
                  fontWeight: "500",
                  color: "#263238",
                  transition: "all 0.3s ease",
                  cursor: "not-allowed",
                  width: "100px",
                  maxWidth: "100px",
                  boxSizing: "border-box",
                }}
                placeholder="Enter Details Here"
                disabled={true}
              />
              <br />
              {validationStatus[index]?.Payment_Receive_Date && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Payment_Receive_Date}
                </span>
              )}
            </TableCell>
            <TableCell sx={{ padding: "2px", width: "120px", maxWidth: "120px", minWidth: "120px", textAlign: "left", verticalAlign: "middle" }}>
              <TextField
                value={row.Bank_Transaction_Id}
                sx={{ 
                  width: "100%",
                  maxWidth: "120px",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    "& fieldset": {
                      borderColor: "rgba(22, 114, 222, 0.15)",
                      borderWidth: "1.5px",
                    },
                    "&:hover": {
                      backgroundColor: "#ffffff",
                      boxShadow: "0 2px 6px rgba(22, 114, 222, 0.1)",
                      "& fieldset": {
                        borderColor: "rgba(22, 114, 222, 0.3)",
                      },
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#ffffff",
                      boxShadow: "0 0 0 3px rgba(22, 114, 222, 0.1)",
                      "& fieldset": {
                        borderColor: "#1672DE",
                        borderWidth: "2px",
                      },
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#f5f7fa",
                      "& fieldset": {
                        borderColor: "rgba(22, 114, 222, 0.08)",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: "6px 8px",
                    fontSize: "11px",
                    fontWeight: "500",
                  },
                }}
                size="small"
                type="text"
                disabled={true}
              />
            </TableCell>
            <TableCell sx={{ padding: "2px", width: "110px", maxWidth: "110px", minWidth: "110px", textAlign: "left", verticalAlign: "middle" }}>
              <TextField
                value={row.Payment_Reference}
                onChange={(e) =>
                  handleInputChange(index, "Payment_Reference", e.target.value)
                }
                sx={{
                  width: "100%",
                  maxWidth: "110px",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    "& fieldset": {
                      borderColor: "rgba(22, 114, 222, 0.15)",
                      borderWidth: "1.5px",
                    },
                    "&:hover": {
                      backgroundColor: "#ffffff",
                      boxShadow: "0 2px 6px rgba(22, 114, 222, 0.1)",
                      "& fieldset": {
                        borderColor: "rgba(22, 114, 222, 0.3)",
                      },
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#ffffff",
                      boxShadow: "0 0 0 3px rgba(22, 114, 222, 0.1)",
                      "& fieldset": {
                        borderColor: "#1672DE",
                        borderWidth: "2px",
                      },
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#f5f7fa",
                      "& fieldset": {
                        borderColor: "rgba(22, 114, 222, 0.08)",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: "6px 8px",
                    fontSize: "11px",
                    fontWeight: "500",
                  },
                }}
                size="small"
                placeholder="Enter Details Here"
                disabled={true}
                InputProps={{
                  endAdornment: (
                    <MoreVertIcon
                      onClick={() =>
                        handlePaymentReferenceOpenDialog(
                          index,
                          row.Payment_Reference
                        )
                      }
                      style={InlineStyles.MoreVertIconStyle}
                    />
                  ),
                }}
              />
              <br />
              {validationStatus[index]?.Payment_Reference && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Payment_Reference}
                </span>
              )}
            </TableCell>
            <TableCell sx={{ padding: "2px", width: "90px", maxWidth: "90px", minWidth: "90px", textAlign: "left", verticalAlign: "middle" }}>
              <CommonSelect
                disabled={true}
                handleChange={(event, value, reason) =>
                  handleInputChange(
                    index,
                    "Payment_Currency_Code",
                    value,
                    reason,
                    event
                  )
                }
                customStyles={{ ...InlineStyles.PaymentCurrency, width: "100%", maxWidth: "90px" }}
                name="payment currncy code"
                // Map through your list of dropdown values
                options={dropdownValuesCurreny?.map(
                  (option) => option.currency_code
                )}
                placeholder="Select Currency"
                value={row.Payment_Currency_Code}
              />
              {validationStatus[index]?.Payment_Currency_Code && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Payment_Currency_Code}
                </span>
              )}
            </TableCell>
            <TableCell sx={{ padding: "2px", width: "100px", maxWidth: "100px", minWidth: "100px", textAlign: "right", verticalAlign: "middle" }}>
              <TextField
                onChange={(e) =>
                  handleInputChange(index, "Receivable_Amount", e.target.value)
                }
                value={numberFormatter(row.Receivable_Amount)}
                onBlur={(e) =>
                  handleBlur(index, "Receivable_Amount", e.target.value)
                }
                sx={{ 
                  width: "100%",
                  maxWidth: "100px",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    "& fieldset": {
                      borderColor: "rgba(22, 114, 222, 0.15)",
                      borderWidth: "1.5px",
                    },
                    "&:hover": {
                      backgroundColor: "#ffffff",
                      boxShadow: "0 2px 6px rgba(22, 114, 222, 0.1)",
                      "& fieldset": {
                        borderColor: "rgba(22, 114, 222, 0.3)",
                      },
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#ffffff",
                      boxShadow: "0 0 0 3px rgba(22, 114, 222, 0.1)",
                      "& fieldset": {
                        borderColor: "#1672DE",
                        borderWidth: "2px",
                      },
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#f5f7fa",
                      "& fieldset": {
                        borderColor: "rgba(22, 114, 222, 0.08)",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: "6px 8px",
                    fontSize: "11px",
                    fontWeight: "500",
                  },
                }}
                size="small"
                type="text"
                InputProps={{
                  inputProps: {
                    onInput: (e) => {
                      e.preventDefault();
                      const value = e.target.value;
                      const regex = /^-?\d*\.?\d{0,2}$/;
                      if (regex.test(value) || value === "" || value === "-") {
                        handleInputChange(index, "Receivable_Amount", value);
                      }
                    },
                  },
                }}
                disabled={true}
                className="right-align"
              />
              <br />
              {validationStatus[index]?.Receivable_Amount && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Receivable_Amount}
                </span>
              )}
            </TableCell>
            <TableCell sx={{ padding: "2px", width: "90px", maxWidth: "90px", minWidth: "90px", textAlign: "left", verticalAlign: "middle" }}>
              <TextField
                onChange={(e) =>
                  handleInputChange(index, "Broker", e.target.value)
                }
                value={row.Broker}
                onBlur={(e) => handleBlur(index, "Broker", e.target.value)}
                sx={{ 
                  width: "100%",
                  maxWidth: "90px",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    "& fieldset": {
                      borderColor: "rgba(22, 114, 222, 0.15)",
                      borderWidth: "1.5px",
                    },
                    "&:hover": {
                      backgroundColor: "#ffffff",
                      boxShadow: "0 2px 6px rgba(22, 114, 222, 0.1)",
                      "& fieldset": {
                        borderColor: "rgba(22, 114, 222, 0.3)",
                      },
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#ffffff",
                      boxShadow: "0 0 0 3px rgba(22, 114, 222, 0.1)",
                      "& fieldset": {
                        borderColor: "#1672DE",
                        borderWidth: "2px",
                      },
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#f5f7fa",
                      "& fieldset": {
                        borderColor: "rgba(22, 114, 222, 0.08)",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: "6px 8px",
                    fontSize: "11px",
                    fontWeight: "500",
                  },
                }}
                size="small"
                type="text"
                InputProps={{
                  inputProps: {
                    onInput: (e) => {
                      e.preventDefault();
                      const value = e.target.value;
                      const regex = /^-?\d*\.?\d{0,2}$/;
                      if (regex.test(value) || value === "" || value === "-") {
                        handleInputChange(index, "BrokerName", value);
                      }
                    },
                  },
                }}
                disabled={true}
              />
              {validationStatus[index]?.Broker && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Broker}
                </span>
              )}
            </TableCell>
            <TableCell sx={{ padding: "2px", width: "100px", maxWidth: "100px", minWidth: "100px", textAlign: "left", verticalAlign: "middle" }}>
              <CommonSelect
                disabled={TroubleshootRounded}
                handleChange={(event, value, reason) =>
                  handleInputChange(index, "dsds", value, reason, event)
                }
                name="Assigned user"
                // Map through your list of dropdown values
                options={dropdownValuesCurreny?.map(
                  (option) => option.currency_code
                )}
                placeholder="Select Assignee"
                value={row?.Assigned_Users[0]?.user_name}
                customStyles={{ width: "100%", maxWidth: "100px" }}
              />
              {validationStatus[index]?.Payment_Currency_Code && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Payment_Currency_Code}
                </span>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
